import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchTrendingTopics as fetchTrendingTopicsService } from "../services/trendingService";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const toErrorMessage = (err, fallback) => {
  if (!err) return fallback;
  if (typeof err === "string") return err;
  return err?.message || fallback;
};

export const fetchTrendingTopicsAsync = createAsyncThunk(
  "trending/fetchTrendingTopics",
  async (userId, { rejectWithValue }) => {
    try {
      const data = await fetchTrendingTopicsService(userId);

      if (Array.isArray(data)) return data;
      if (Array.isArray(data?.items)) return data.items;

      return [];
    } catch (error) {
      console.error("Failed to fetch trending topics:", error);
      return rejectWithValue(toErrorMessage(error, "Failed to fetch trending topics."));
    }
  }
);

const trendingSlice = createSlice({
  name: "trending",
  initialState,
  reducers: {
    clearTrendingError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrendingTopicsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTrendingTopicsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload || [];
      })
      .addCase(fetchTrendingTopicsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch trending topics.";
      });
  },
});

export const { clearTrendingError } = trendingSlice.actions;

// Safe selectors
export const selectTrendingTopics = (state) => state.trending?.items || [];
export const selectTrendingLoading = (state) => state.trending?.loading || false;
export const selectTrendingError = (state) => state.trending?.error || null;

export default trendingSlice.reducer;
